// extracted by mini-css-extract-plugin
export default {"sso-body":"zsjqIXQQrIMAVcoXtJQ8","protocol-content":"aHKwY3a6U16sn0G7tE0Y","description":"WXU3_CysISryfIQVNyyC","user-directory-form":"PjDZK14mguzcI0fIjQrg"};